export enum ReservationMode {
    Outright = "outright",
    Deposit = "deposit",
    Option = "option"
}